import api from '../helpers';

export default {
  // Check if company can transfer
  canTransfer: {
    key: 'fetchDeploymentTransferCanTransfer',
    query: (companyId) => {
      return api.get(`/api/v1/deployment-transfer/can-transfer/${companyId}`);
    },
  },

  // Sender Configuration
  getSenderConfig: {
    key: 'fetchDeploymentTransferSenderConfig',
    query: (companyId) => {
      return api.get(`/api/v1/deployment-transfer/config/sender/${companyId}`);
    },
  },
  createSenderConfig: {
    key: 'createDeploymentTransferSenderConfig',
    query: (companyId, data) => {
      return api.post(`/api/v1/deployment-transfer/config/sender/${companyId}`, { data });
    },
  },
  regenerateSenderApiKey: {
    key: 'regenerateDeploymentTransferSenderApiKey',
    query: (companyId) => {
      return api.post(`/api/v1/deployment-transfer/config/sender/${companyId}/regenerate-key`);
    },
  },
  deleteSenderConfig: {
    key: 'deleteDeploymentTransferSenderConfig',
    query: (companyId) => {
      return api.delete(`/api/v1/deployment-transfer/config/sender/${companyId}`);
    },
  },

  // Receiver Configuration
  getReceiverConfig: {
    key: 'fetchDeploymentTransferReceiverConfig',
    query: (companyId) => {
      return api.get(`/api/v1/deployment-transfer/config/receiver/${companyId}`);
    },
  },
  createReceiverConfig: {
    key: 'createDeploymentTransferReceiverConfig',
    query: (companyId, data) => {
      return api.post(`/api/v1/deployment-transfer/config/receiver/${companyId}`, { data });
    },
  },
  deleteReceiverConfig: {
    key: 'deleteDeploymentTransferReceiverConfig',
    query: (companyId) => {
      return api.delete(`/api/v1/deployment-transfer/config/receiver/${companyId}`);
    },
  },

  // Transfer Operations
  getTransferStatus: {
    key: 'fetchDeploymentTransferStatus',
    query: (companyId) => {
      return api.get(`/api/v1/deployment-transfer/status/${companyId}`);
    },
  },
  transferAll: {
    key: 'deploymentTransferAll',
    query: (companyId) => {
      return api.post(`/api/v1/deployment-transfer/transfer-all/${companyId}`);
    },
  },

  // S3 Migration
  s3Migrate: {
    key: 'deploymentTransferS3Migrate',
    query: (companyId) => {
      return api.post(`/api/v1/deployment-transfer/s3-migrate/${companyId}`);
    },
  },
  getS3Status: {
    key: 'fetchDeploymentTransferS3Status',
    query: (companyId) => {
      return api.get(`/api/v1/deployment-transfer/s3-status/${companyId}`);
    },
  },
};
